import * as types from "./actionsTypes";
import { getCart } from "../../api/shop";

export function setProducts(products) {
  return {
    type: types.SET_PRODUCTS,
    data: products
  };
}

export function setCategories(categories) {
  return {
    type: types.SET_CATEGORIES,
    data: categories
  };
}

export function setCart(cart) {
  return {
    type: types.SET_CART,
    data: cart
  };
}

export function refreshCart() {
  return function (dispatch) {
    return getCart().then(cart => dispatch(setCart(cart)));
  };
}

export function setOpen(bool) {
  return {
    type: types.SET_OPEN,
    data: bool
  };
}

export function resetStore() {
  return {
    type: types.RESET_STORE
  };
}

export function setAddress(address) {
  return {
    type: types.SET_ADDRESS,
    data: address,
  };
}

export function resetAddress() {
  return {
    type: types.RESET_ADDRESS
  };
}

